// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__DLURT","dragIcon":"SortableItem_dragIcon__BrmIl","disabled":"SortableItem_disabled__2KCvK"};